/**
 * Composant pour gérer les raccourcis clavier globaux de l'application
 * Tous les raccourcis ont été supprimés sauf ESC et Ctrl+S qui sont gérés localement dans chaque composant
 */
const GlobalKeyboardShortcuts = () => {
  // Aucun raccourci global - ESC et Ctrl+S sont gérés localement dans les composants
  return null;
};

export default GlobalKeyboardShortcuts;

